'use client';

import { Slice } from 'gatsby';
import React, { type FC, useContext, useEffect, useState } from 'react';

import { ThemeButton } from '@/components/buttons/theme-button';
import { ParamLink } from '@/components/links/param-link';
import { MediaQueryContext } from '@/context/media-query';
import t from '@/i18n/current';
import { cn } from '@/utils/class-name';

export const Header: FC = () => {
    const resolution = useContext(MediaQueryContext);
    const [isActive, setIsActive] = useState(false);

    const toggleNavigation = (): void => {
        setIsActive(!isActive);
    };

    const disableNavigation = (): void => {
        setIsActive(false);
    };

    useEffect(() => {
        disableNavigation();
    }, [resolution.desktop]);

    return (
        <header className={cn('header d-flex ai-center bg-white-gray', isActive && 'open')}>
            <div className="container d-flex ai-center g-16">
                <Slice alias="header-extra" />

                <ThemeButton />

                <div className="d-flex jc-end" style={{ flex: '1 1' }}>
                    <button
                        className="header-toggler d-lg-none"
                        aria-label={isActive ? 'Zamknij główną nawigację' : 'Otwórz główną nawigację'}
                        onClick={toggleNavigation}
                    >
                        <span></span>
                        {!isActive && <span></span>}
                        <span></span>
                    </button>
                </div>

                <nav className="header-panel bg-white-gray d-none d-lg-flex">
                    <ul className="list unstyled-list g-16 c-secondary container flex-lg-row">
                        {t.navigation.header.map((link, id) => (
                            <li key={id}>
                                <ParamLink to={link.url} className="d-flex fs-18">
                                    {link.name}
                                </ParamLink>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>

            {isActive && <div className="header-close" onClick={disableNavigation}></div>}
        </header>
    );
};
